import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const WaybillManagement = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        İrsaliye Yönetimi
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>İrsaliye yönetimi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default WaybillManagement;
